import "./Services.module.css";
import MainNavigation from "@/reusable_sections/Header";
import CommunityPillars from "./sections/CommunityPillars";
import EmergencyRapidResponse from "./sections/EmergencyRapidResponse";
import BrandFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <MainNavigation />
      <CommunityPillars />
      <EmergencyRapidResponse />
      <BrandFooter />
    </div>;
}